'use client'
import { useState, useEffect } from 'react';

export function useIsMobile(breakpoint: number = 640): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const controller = new AbortController();

    setIsMobile(window.innerWidth < breakpoint);

    const handleResize = () => {
      if (!controller.signal.aborted) {
        setIsMobile(window.innerWidth < breakpoint);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      controller.abort();
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
}

